import { IDCountry } from "src/app/components/InsightsDashboard/panes/InsightsDashboardSetupPane/InsightsDashboardSetupPane";

export interface InsightsDashboardFilters {
  countries: IDCountry[];
  platforms: string[];
  hashtags: string[];
  mentions: string[];
}

export type CriteriaOptionValue = "or" | "and";

export interface CriteriaOption {
  value: CriteriaOptionValue;
  label?: string;
}

export enum WorkspacePublicationsType {
  All = "all",
  WorkspaceOnly = "workspaceOnly",
  WorkspaceExcluded = "workspaceExcluded",
}

export interface InsightsDashboardSetup extends InsightsDashboardFilters {
  workspacePublicationsType: WorkspacePublicationsType;
  hashtagsCriteria: CriteriaOption;
  mentionsCriteria: CriteriaOption;
  hashtagsMentionsCriteria: CriteriaOption;
}

export interface InsightsDashboardSetupConfig {
  breakdowns: string[];
  countries: IDCountry[];
  wsCountries: IDCountry[];
}
